define('viewmodels/app/__utils',['chartApi/index'], function(chartApi) {
    'use strict';

    var CUSTOM_DURATION_ID = 'custom';

    return {
        reportSummaryFromModel: reportSummaryFromModel,
        reportSummaryFromDashboard: reportSummaryFromDashboard,
        reportConfigFromDashboard: reportConfigFromDashboard
    };

    function reportSummaryFromModel(chartList) {
        var summary = _.map(chartList, function(chart) {
            var chartConfig = _.find(chartApi.matrixCharts.charts, function(chartConfig) {
                    return chartConfig.chartId === chart.chartId()
                }),
                summaryText = chartConfig.i18n.TITLE,
                durationFilter = _.find(chart.filters(), function(filter) {
                    return filter.type() === 'duration';
                });

            if (durationFilter) {
                var selectedChoice = _.find(
                    chartApi.matrixCharts.$c.filters.DURATION.choices,
                    function(choice) {
                        return (
                            choice.apiValue.value === durationFilter.value() &&
                            choice.apiValue.unit === durationFilter.unit()
                        );
                    }
                );

                if (selectedChoice) {
                    summaryText += ': ' + selectedChoice.text;
                }
            }
            return summaryText;
        });
        return summary;
    }

    function reportSummaryFromDashboard(dashboardCharts, onlyDefault) {
        var returnDescArray = _.map(dashboardCharts, function(chart){
            return singleReportSummary(chart, onlyDefault);
        });
        return returnDescArray;
    }


    function singleReportSummary(chart, onlyDefault){
        var durationFilter = _.find(chart.filters, {
                id: 'duration'
            }),
            chartDesc = chart.chartConfig.i18n.TITLE;

        if (durationFilter) {
            var DURATION = matrixCharts.$c.filters.DURATION;
            var defaultChoiceText = _.find(DURATION.choices, {
                    id: DURATION.default
                }).text,
                useDefault = onlyDefault || CUSTOM_DURATION_ID === durationFilter.value.id,
                durationSelectedText = useDefault ? defaultChoiceText : durationFilter.selectedChoiceText();
            chartDesc += ': ' + durationSelectedText;
        }

        return chartDesc;
    }

    function reportConfigFromDashboard(dashboardCharts, onlyDefault) {
        var chartConfig = _.map(dashboardCharts, function(chart) {
            var singleChartConfig = {
                    chartId: chart.chartConfig.chartId,
                    filters: []
                },
                durationFilter = _.find(chart.filters, {
                    id: 'duration'
                });

            if (durationFilter) {
                var useDefault = onlyDefault || CUSTOM_DURATION_ID === durationFilter.value.id,
                    durationFilterId = useDefault ? matrixCharts.$c.filters.DURATION.default : durationFilter.value.id,
                    seletedDurationChoice = _.find(
                        matrixCharts.$c.filters.DURATION.choices, {
                            id: durationFilterId
                        }
                    );
                if (seletedDurationChoice) {
                    singleChartConfig.filters.push({
                        type: 'duration',
                        value: seletedDurationChoice.apiValue.value,
                        unit: seletedDurationChoice.apiValue.unit
                    });
                }
            }

            return singleChartConfig;
        });
        return chartConfig;
    }
});

